import React from 'react';
import { Container, Typography } from '@mui/material';

const Activities = () => {
  return (
    <Container maxWidth="lg">
      <Typography variant="h4" component="h1" gutterBottom>
        Activities
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Jordan Webb is actively involved in various amateur radio and community activities. As the District 5
        Assistant Skywarn Coordinator and a net control station for East Tennessee SKYWARN, he plays a vital role in
        weather spotting and community safety.
      </Typography>
    </Container>
  );
};

export default Activities;
